import styled, { css } from 'styled-components'
import type { ListProps } from './types'

export const ListContainer = styled.div<{
  $direction: NonNullable<ListProps['direction']>
}>`
  display: flex;
  list-style-type: none;
  flex-direction: row;
  gap: var(--space-300);

  ${({ $direction }) =>
    $direction === 'vertical' &&
    css`
      flex-direction: column;
      margin-right: var(--space-600);
    `}
`
